// removed by extract-text-webpack-plugin
module.exports = {"Wrapper":"_1ST1d"};


//////////////////
// WEBPACK FOOTER
// ./src/hoc/Layout/Layout.scss
// module id = 661
// module chunks = 0